/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CandidateNoteStorePathParams,
	CandidateNoteStoreRequest,
	CandidateNoteStoreResponse,
} from '../types/CandidateNoteStore'

/**
 * POST /candidates/:candidate/notes
 * @see backend/nexus/modules/Campaign/Http/Controllers/CandidateNoteController.php CandidateNoteController::store
 */
export async function candidateNoteStore(
	candidate: CandidateNoteStorePathParams['candidate'],
	data: CandidateNoteStoreRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CandidateNoteStoreResponse>> {
	return axiosInstance.post(`/candidates/${candidate}/notes`, data, config)
}
